// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 281) return "static/chunks/281-0e22cbc653b4bc57.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 240 ? "c36f3faa" : chunkId) + "." + {"240":"5d1269412edd728a","3976":"634bfc3af45f6869","4539":"c05881cdcbd7e5ea"}[chunkId] + ".js";
};